import { StringUtils } from '../utils/StringUtils';

// Will result in a kebab string of kebabified args
export const formatDataTest = (...args) => {
  const dataTestId = args.map(arg => {
    if (
      arg &&
      (!StringUtils.isKebabConvention(arg) || /^\d+$/.test(arg))
    ) {
      return '"' + arg + '"';
    }
    return arg;
  }).join('-');
  return dataTestId;
}
